export default {
    ABORTO_ESPONTANEO: 'W82',
    ABORTO_PROVOCADO: 'W83',
    ABUSO_AGUDO_DE_ALCOOL: 'P16',
    ABUSO_DE_DROGAS: 'P19',
    ABUSO_DO_TABACO: 'P17',
    ASMA: 'R96',
    DEFICIENCIA_VITAMINICA_NUTRICIONAL: 'T91',
    DENGUE_E_OUTRAS_DOENCAS_VIRAIS_NE: 'A77',
    DIABETES_GESTACIONAL: 'W85',
    DIABETES_NAO_INSULINO_DEPENDENTE: 'T90',
    DOENCA_PULMONAR_OBSTRUTIVA_CRONICA: 'R95',
    FATOR_DE_RISCO_PARA_DOENCA_CARDIOVASCULAR: 'K22',
    GRAVIDEZ: 'W78',
    GRAVIDEZ_DE_ALTO_RISCO: 'W84',
    GRAVIDEZ_ECTOPICA: 'W80',
    GRAVIDEZ_NAO_DESEJADA: 'W79',
    HANSENIASE_E_OUTRAS_DOENCAS_INFECCIOSAS_NE: 'A78',
    HIPERTENSAO_SEM_COMPLICACOES: 'K86',
    INFECCOES_QUE_COMPLICAM_A_GRAVIDEZ: 'W71',
    MEDICINA_FISICA_REABILITACAO: '57',
    MEDICINA_PREVENTIVA_MANUTENCAO_DA_SAUDE: 'A98',
    OBESIDADE: 'T82',
    PARTO_COM_COMPLICACOES_DE_NASCIDO_VIVO: 'W92',
    PARTO_COM_COMPLICACOES_DE_NATIMORTO: 'W93',
    PARTO_SEM_COMPLICACOES_DE_NASCIDO_VIVO: 'W90',
    PARTO_SEM_COMPLICACOES_DE_NATIMORTO: 'W91',
    SINAIS_SINTOMAS_POS_PARTO: 'W18',
    TOXEMIA_GRAVIDICA_DHEG: 'W81',
    TUBERCULOSE: 'A70',
    CONSULTA_COM_PROFISSIONAL_DE_APS: '46',
    OUTROS_PROCEDIMENTOS_PREVENTIVOS: '49'
}